import { Divider, Form, Input, Spin, Table } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import DocumentAdd from "./DocumentAdd";
import ConfirmModal from "../../../../components/ConfirmModal";
import Search from "../../../../components/Search";
import {
  downloadFile,
  formatImgPathSecure,
  previewPaper,
} from "../../../../utils";
import CardLoading from "../../../../components/CardLoading";
import svg46 from "../../../../assets/svg/svg46.svg";
import svg59 from "../../../../assets/svg/svg59.svg";
import svg76 from "../../../../assets/svg/svg76.svg";
import deleteSvg from "../../../../assets/svg/delete-red.svg";
import {
  fetchData,
  fetchFilesSecured,
} from "../../../../features/dropdown/dropdownSlice";
import { save } from "../../../../features/save/saveSlice";

function DocImages({ handleNext, handleBack }) {
  const { open, handleCancel, handleOpen } = useModalToggle();
  const url = "v1/api/att/fetchAll";
  const { saving } = useSelector((state) => state.save);

  const { activeObjJob, loading, data, count } = useSelector((state) => ({
    loading: state.dropdown.loading,
    data: state.dropdown.data[url] || [],
    count: state.dropdown.count[url] || 0,
    activeObjJob: state.folder.activeObj["job"],
  }));

  const { refetchKey } = useSelector((state) => state.folder);
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        attJobId: activeObjJob?.jobId,
        attName: e.target.value == "" ? null : e.target.value,
      })
    );
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [prodd1, setProdd1] = useState();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = async (item) => {
    await setProdd(item);
    await setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: `v1/api/att/delete/${prodd?.attId}`,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleAdd = async () => {
    await handleOpen();
  };
  const handlePrev = () => {
    handleBack();
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        attJobId: activeObjJob?.jobId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    if (refetchKey == 2) {
      fetchTableData();
    }
  }, [refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <>
      <div className="flex  flex-col gap-[1.25rem]  ">
        <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between lg:mt-[.25rem] gap-y-4">
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>
          <div className="w-[130px]">
            <button onClick={handleAdd} className="cstm-btn">
              <img src={svg76} alt="svg76" />{" "}
              <span className="ml-1">Upload</span>
            </button>
          </div>
        </div>

        <div className="custom-title  mt-[1rem]">Uploaded Images</div>
        <div className="flex items-center flex-shrink flex-wrap gap-[1.25rem]">
          {data &&
            data?.map((item) => (
              <div className="flex flex-col w-[15rem]">
                <img
                  loading="lazy"
                  className="w-full h-[10rem] object-cover"
                  src={formatImgPathSecure(item?.attFile)}
                  alt={item?.attName}
                />

                <div className="flex items-center justify-between w-full border border-[#E3E5E5] rounded-t-[0.25rem] p-[.5rem] text-[#090A0A] text-[.75rem] font-[400] font-interSans">
                  <span className=" truncate max-w-full overflow-hidden whitespace-nowrap">
                    {item?.attName}
                  </span>

                  <div
                    className="flex items-center gap-x-[.62rem]"
                    onClick={() => setProdd(item)}
                  >
                    <img
                      src={svg59}
                      alt="svg59"
                      className="cursor-pointer"
                      onClick={() => downloadFile(item?.attFile, item?.attName)}
                    />
                    <img
                      className="cursor-pointer"
                      src={deleteSvg}
                      alt="deleteSvg"
                      onClick={() => handleOpenDelete()}
                    />
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>

      <DocumentAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
        prodd1={prodd1}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={saving}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </>
  );
}

export default DocImages;
